export enum PromptRenderMethod {
    RAW, CODE, CHIPS
}
